<template>
    <div class="flats-crm-items-container flats-items-grid" v-if="flatsItems != null">
        <div class="flats-empty-msg" v-if="flatsEmptyMsg"><p>{{flatsPage.flats_cards_info.flat_not_found_msg}}</p></div>
        <div class="flats-items" v-if="!flatsEmptyMsg">
            <div class="flat-item" v-for="item in flatsItems" :key="item.id">
                <router-link :to="{ name: 'flat-crm-card' , params:{'id' : item.id}}" class="item-link" @click.native="startLoader">
                    <div class="item-default item-img" v-if="item != null && item.id != null">
                        <!-- <div class="img-in" v-if="item.images.length > 0">
                            <img :src="ucoCRMurl + '/rest/prices/getImage?imageId=' + pic.id"  alt="" v-for="pic in item.images" v-if="pic.typeCode == '1'">
                        </div> -->
                        <div class="img-in" v-if="item.images.length > 0">
                            <img :src="'https://bazis-online.kz/crmc/rest/prices/getImage?imageId=' + pic.id" v-for="(pic, index) in item.images.filter(item => item.typeCode === '1')" :key="index">
                        </div>
                        <div class="btns-active">
                            <div class="btn-item btn-to-favorite">
                                <a href="#" class="favorite-link btn-link" @click.prevent="sendToFavorite(item.id), checkerClass($event)" :class="{'active' : checkProjectFavorite(item.id)}">
                                    <!-- <svgIcon name="star" class="icon-star"/> -->
                                    <svgIcon name="star-sales" class="icon-star"/>
                                </a>
                            </div>
                            <div class="btn-item btn-to-compare">
                                <a href="#" class="compare-link btn-link" @click.prevent="sendToCompare(item.id), checkerClass($event)" :class="{'active' : checkProjectCompare(item.id)}">
                                    <svgIcon name="ab" class="icon-ab"/>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="item-desc">
                        <div class="item-title">
                            <span class="rooms">{{item.rooms}}</span> {{flatsPage.flats_cards_info.flat_name}}, <span>{{item.area}} <b>м²</b></span>
                        </div>
                        <div class="item-info">
                            <ul>
                                <li>
                                    <div class="left">
                                        {{flatsPage.flats_cards_info.flat_object_name}}
                                    </div>
                                    <!-- v-if="item.complexCode != 'LDM'" -->
                                    <div class="right" >
                                        <span v-if="item.complexCode != 'LDM' && item.complexCode != 'LDM-II' && item.complexCode != 'LDM-III' && item.complexCode != 'LDM-IV' && item.complexCode != 'PVS' && item.complexCode != 'PVG' && item.complexCode != 'VSP' && item.complexCode != 'VSP1' && item.complexCode != 'VSP2'">{{item.complexName.replace(/['"]+/g, '')}}</span>
                                        <span v-else>{{item.complexName.replace(/\,.*/,'')}}</span>
                                    </div>
                                </li>
                                <li>
                                    <div class="left">
                                        {{flatsPage.flats_cards_info.flat_size}}
                                    </div>
                                    <div class="right">
                                        {{item.area}} <span>м²</span>
                                    </div>
                                </li>
                                <li class="price" v-if="item.showPricesOnSaleSite == true">
                                    <div class="left">
                                        {{flatsPage.flats_cards_info.flat_price}} м²
                                    </div>
                                    <div class="right">
                                        <span v-if="globalLang == ''">от</span><span v-if="globalLang == 'en/'">from</span>
                                        {{getNumber(item.meterPrice)}} 
                                        <span v-if="globalLang == ''">тг.</span><span v-if="globalLang == 'en/'">tg</span><span v-if="globalLang == 'kz/'">тг. бас.</span>
                                    </div>
                                </li>
                                <li class="price" v-if="item.showPricesOnSaleSite == true">
                                    <div class="left">
                                        {{flatsPage.flats_cards_info.flat_full_price}}
                                    </div>
                                    <div class="right">
                                        <span v-if="globalLang == ''">от</span><span v-if="globalLang == 'en/'">from</span>
                                        {{getNumberMillion(item.totalPrice)}} 
                                        <span v-if="globalLang == ''">млн.тг</span><span v-if="globalLang == 'en/'">m.tg.</span><span v-if="globalLang == 'kz/'">млн.тг бас.</span>
                                    </div>
                                </li>
                                <li>
                                    <div class="left">
                                        {{flatsPage.flats_cards_info.flat_floor}}
                                    </div>
                                    <div class="right">
                                        {{item.floor}}
                                    </div>
                                </li>
                                <li>
                                    <div class="left">
                                        {{flatsPage.flats_cards_info.flat_flat_number}}
                                    </div>
                                    <div class="right">
                                        {{item.number}}
                                    </div>
                                </li>
                                <li>
                                    <div class="left">
                                        <span v-if="item.complexCode != 'SOH'">{{flatsPage.flats_cards_info.flat_bloom}}</span>
                                        <span v-if="item.complexCode == 'SOH'">{{flatsPage.flats_cards_info.flat_kvartal}}</span>
                                    </div>
                                    <div class="right" v-if="item.complexCode != 'DSV' && item.complexCode != 'LDM' && item.complexCode != 'LDM-II' && item.complexCode != 'LDM-III' && item.complexCode != 'LDM-IV' && item.complexCode != 'SOH' && item.complexCode != 'MNC'">
                                        {{getNumbersOfString(item.blockName)}}
                                    </div>
                                    <div class="right" v-if="item.complexCode == 'DSV' || item.complexCode == 'LDM' || item.complexCode == 'LDM-II' || item.complexCode == 'LDM-III' || item.complexCode == 'LDM-IV'">
                                        {{getNumbersOfBlockDiscovery(item.blockName)}}
                                    </div>
                                    <div class="right" v-if="item.complexCode == 'MNC'">
                                        {{ getNumbersOfBlockMonaco(item.blockName) }}
                                    </div>
                                    <div class="right" v-if="item.complexCode == 'SOH'">
                                        {{getNumbersOfBlockSoho(item.blockName)}}
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div class="item-btns">
                        <!-- {{complexData.project_name.slug }} -->
                            <!-- {{item.blockName}} -->
                            <!-- {{item.complexCode}} -->
                            <!-- <div v-if="item.complexCode == 'ALF' || 
                                       item.complexCode == 'EST' ||
                                       item.complexCode == 'JAZ' ||
                                       item.complexCode == 'LEG' ||
                                       item.complexCode == 'MTR' ||
                                       item.complexCode == 'ОRI' ||
                                       item.complexCode == 'PRV' ||
                                       item.complexCode == 'RIV' ||
                                       item.complexCode == 'AUS' ||
                                       item.complexCode == 'MNC' ||
                                       item.complexCode == 'SOH' ||
                                       item.complexCode == 'EVL' ||
                                       item.complexCode == 'ZGR' ||
                                       item.complexCode == 'ZGR' ||
                                       item.complexCode == 'STP' ||
                                       item.complexCode == 'LDM' ||
                                       item.complexCode == 'LDM-II' ||
                                       item.complexCode == 'LDM-III' ||
                                       item.complexCode == 'LDM-IV' 
                            "> -->
                            <div>
                                <a 
                                    :href="URLrocketLC + '/?apartment_id=' + item.id +'&method=book&lang=' + langVAR" class="bron" target="_blank" 
                                    @click.prevent="linkToLogin(URLrocketLC + '/?apartment_id=' + item.id +'&method=book&lang=' + langVAR, 'book')"
                                    v-if="item.isApartmentReserved"
                                    >{{flatsPage.flats_cards_info.flat_btn_book_name}}
                                </a>
                                <span v-else class="btn-off bron-off">{{flatsPage.flats_cards_info.flat_btn_book_name}}</span>
                                <a 
                                    :href="URLrocketLC + '/?apartment_id=' + item.id +'&method=by&lang=' + langVAR" class="by" target="_blank" 
                                    @click.prevent="linkToLogin(URLrocketLC + '/?apartment_id=' + item.id +'&method=by&lang=' + langVAR, 'by')" 
                                    v-if="item.hasJointVentureAgreement"
                                    >{{flatsPage.flats_cards_info.flat_btn_by_name}}
                                </a>
                                <span v-else class="btn-off by-off">{{flatsPage.flats_cards_info.flat_btn_by_name}}</span>
                            </div>
                            <!-- </div> -->
                            <!-- <div v-else>
                                <a 
                                    :href="URLrocketLC + '/?apartment_id=' + item.id +'&method=book&lang=' + langVAR" class="bron" target="_blank" 
                                    @click.prevent="linkToLogin(URLrocketLC + '/?apartment_id=' + item.id +'&method=book&lang=' + langVAR, 'book')"
                                    v-if="checkConfirmPurchase('book', item.complexCode, item.blockName)"
                                    >{{flatsPage.flats_cards_info.flat_btn_book_name}}
                                </a>
                                <span v-else class="btn-off bron-off">{{flatsPage.flats_cards_info.flat_btn_book_name}}</span>
                                <a 
                                    :href="URLrocketLC + '/?apartment_id=' + item.id +'&method=by&lang=' + langVAR" class="by" target="_blank" 
                                    @click.prevent="linkToLogin(URLrocketLC + '/?apartment_id=' + item.id +'&method=by&lang=' + langVAR, 'by')" 
                                    v-if="checkConfirmPurchase('by', item.complexCode, item.blockName)"
                                    >{{flatsPage.flats_cards_info.flat_btn_by_name}}
                                </a>
                                <span v-else class="btn-off by-off">{{flatsPage.flats_cards_info.flat_btn_by_name}}</span>
                            </div> -->
                            <div class="hypothec-btn" :class="{'disabled-link' : !item.hasMortgage}">
                                <router-link :to="{ name: 'flat-crm-card' , params:{'id' : item.id}, hash: '#flat-crm-card-online-payment'}" v-if="item.hasMortgage" @click.native="setYMstat">{{ flatsPage.flats_cards_info.flat_btn_hypothec_online_name }}</router-link>
                                <span v-else class="btn-off">{{ flatsPage.flats_cards_info.flat_btn_hypothec_online_name }}</span>
                            </div>
                        </div>
                    </div>
                </router-link>
                <!-- <a href="#" class="getPrice" @click.prevent="openFormModal(true)">ЗАПРОСИТЬ ЦЕНУ</a> -->
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue';
    export default {
        name: 'flats-item',
        components: {
            svgIcon,
        },
        data () {
            return {
                globalLang: window.GlobalLang,
                langVAR: window.LangVar,
                blockPart: null,
            }
        },
        computed: mapGetters({
            flatsPage: 'loadFlatsPage',
            flatsItems: 'loadFlatsItems',
            flatsEmptyMsg: 'loadFlatsEmptyMsg',
            ucoCRMurl: 'loadUrlCRMuco',
            URLrocketLC: 'loadUrlRocketLC',
        }),
        methods: {
            getNumbersOfString(str) {
                return str.replace(/[^0-9]+/g, "");
            },
            getNumbersOfBlockDiscovery(str) { 
                var parseStr = str.split(',')[0];
                return parseStr.replace('Пятно', '');
            },
            getNumbersOfBlockLandmark(str) {
                var parseStr = str.split(',')[0];
                return parseStr.replace('Пятно', '');
            },
            getNumbersOfBlockSoho(str) {
                var parseStr = str.split(',')[0];
                return parseStr.replace('Квартал', '').replace(/ /g, '');
            },
            getNumbersOfBlockMonaco(str) {
                var parseStr = str.split(',')[0];
                return parseStr.replace('Пятно', '').replace(/ /g, '');
            },
            getBlockPartLDM(str) {
                var blockPart;
                blockPart = str.split(',')[1];
                blockPart = parseInt(blockPart);
                return blockPart;
            },
            getBlockPartSOH(str) {
                var blockPart;
                blockPart = str.split(',')[1];
                blockPart = blockPart.replace('Блок', '');
                blockPart = blockPart.replace(/ /g, '');
                return blockPart;
            },
            getBlockPartMNC(str) {
                var blockPart;
                blockPart = str.split(',')[1];
                blockPart = blockPart.replace('Блок', '');
                blockPart = blockPart.replace(/ /g, '');
                return blockPart;
            },
            getNumber(n) {
                return String(n).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.")
            },
            getNumberMillion(n) {
                const num = String(n).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.");
                return parseFloat(num).toFixed(1);
            },
            openCrmFlatModal(arr) {
                this.$store.commit('modalData', arr);
                setTimeout(() => {
                    this.$modal.show('sales_land_flat_card_crm_modal');
                }, 300);
            },
            startLoader() {
                // this.$parent.$parent.$refs.topProgress.start();
            },
            openFormModal(param) {
                this.$store.commit('Open_Form_Modal', param);
            },
            sendToFavorite(id) { // Добавление квартиры в избранное
                // console.log(id, 'arr flat favorite', localStorage.getItem('favorite_flats'));
                // Получаем уже хранившиеся квартиры если есть из LocalStorage
                var exist = localStorage.getItem('favorite_flats');
                exist = exist ? exist.split(',') : [];
                // Проверяем есть ли уже такая квартира в Storage
                var finder = exist.find(item => item == id);
                // console.log(finder, 'НАЛИЧИЕ');

                if (finder == undefined) {
                    exist.push(id);
                    localStorage.setItem('favorite_flats', exist);
                    // this.$store.commit('setFavoriteCount', exist.length);
                    // console.log(exist);
                } else {
                    var filterExist = exist.filter(item => {
                        return item != id
                    })
                    localStorage.setItem('favorite_flats', filterExist);
                    // this.$store.commit('setFavoriteCount', filterExist.length);
                    // console.log(exist);
                }
            },
            sendToCompare(id) { // Добавление квартиры в сравнение
                // console.log(id, 'arr flat favorite', localStorage.getItem('favorite_flats'));
                // Получаем уже хранившиеся квартиры если есть из LocalStorage
                var exist = localStorage.getItem('sales_compare_flats');
                exist = exist ? exist.split(',') : [];
                // Проверяем есть ли уже такая квартира в Storage
                var finder = exist.find(item => item == id);
                // console.log(finder, 'НАЛИЧИЕ');
                if (finder == undefined) {
                    exist.push(id);
                    localStorage.setItem('sales_compare_flats', exist);
                    // this.$store.commit('setFavoriteCount', exist.length);
                    // console.log(exist);
                } else {
                    var filterExist = exist.filter(item => {
                        return item != id
                    })
                    localStorage.setItem('sales_compare_flats', filterExist);
                    // this.$store.commit('setFavoriteCount', filterExist.length);
                    // console.log(exist);
                }
            },
            checkProjectFavorite(id) {
                var items = localStorage.getItem('favorite_flats');
                items = items ? items.split(',') : [];
                // this.$store.commit('setFavoriteCount', items.length);
                var finder = items.find(item => item == id);
                // console.log(finder)
                if (finder != undefined) {
                    return true
                } else {
                    return false
                }
            },
            checkProjectCompare(id) {
                var items = localStorage.getItem('sales_compare_flats');
                items = items ? items.split(',') : [];
                // this.$store.commit('setFavoriteCount', items.length);
                var finder = items.find(item => item == id);
                // console.log(finder)
                if (finder != undefined) {
                    return true
                } else {
                    return false
                }
            },
            checkerClass(event) {
                event.currentTarget.classList.toggle('active');
            },
            linkToLogin(url, method) {
                // console.log(url);
                var exist = localStorage.getItem('favorite_flats');
                exist = exist ? exist.split(',') : [];
                // var url = 'https://bazis-a.rocketfirm.net';
                var favoriteUrl;
                if (method == 'book') {
                    ym(57579163,'reachGoal','flat_book_item');
                } else if (method == 'by') {
                    ym(57579163,'reachGoal','flat_by_item')
                }
                // ym(57579163,'reachGoal','flat_hypothec_btn')
                if (exist.length > 0) {
                    favoriteUrl = '&favoritesFlats=' + exist.join(',');
                    // console.log(exist, favoriteUrl);
                    window.open(
                        url + favoriteUrl,
                        '_blank'
                    );
                } else {
                    window.open(
                        url,
                        '_blank'
                    );
                }
            },
            setYMstat() {
                // console.log('click native')s
                ym(57579163,'reachGoal','flat_hypothec_btn');
            },
            checkConfirmPurchase(param, code, blockName) {
                // console.log(param, code, blockName)
                var blockNameBparse = blockName;
                if (code != 'DSV' && code != 'LDM' && code != 'SOH' && code != 'MNC') {
                    blockName = this.getNumbersOfString(blockName);
                } else if (code == 'DSV') { 
                    blockName = parseInt(this.getNumbersOfBlockDiscovery(blockName));
                } else if (code == 'LDM') {
                    blockName = parseInt(this.getNumbersOfBlockLandmark(blockName));
                } else if (code == 'SOH') {
                    blockName = this.getNumbersOfBlockSoho(blockName);
                } else if (code == 'MNC') {
                    blockName = this.getNumbersOfBlockMonaco(blockName);
                }
                // console.log(blockName, blockNameBparse)

                if (param == 'book') {
                    if (code == 'AKV') { // Настройка кнопок Акварель
                        if (blockName == '25' || blockName == '26' || blockName == '27' || blockName == '28') {
                            return true;
                        } else {
                            return false;
                        }
                    } else if (code == 'RPR') { // Настройка кнопок Remizovka
                        if (blockName == '12' || blockName == '15' || blockName == '17') {
                            return true;
                        } else {
                            return false;
                        }
                    }
                    // ASTANA
                    else if (code == 'DSV') { // Настройка кнопок Discovery
                        if (blockName == '4') {
                            return true;
                        } else {
                            return false;
                        }
                    } else if (code == 'LDM') { // Настройка кнопок Landmark
                        // console.log(this.blockPart, this.getBlockPartLDM(blockNameBparse), 'asdasdasdasd213123123123123')
                        if (this.getBlockPartLDM(blockNameBparse) == 3) {
                            if (blockName == '1') {
                                return true;
                            } else {
                                return false;
                            }
                        } else if (this.getBlockPartLDM(blockNameBparse) == 4) {
                            if (blockName == '1' || blockName == '2' || blockName == '3') {
                                return true;
                            } else {
                                return false;
                            }
                        }
                        
                    } else if (code == 'SOH') { // Настройка кнопок Soho
                        if (blockName == '2A') {
                            if (this.getBlockPartSOH(blockNameBparse) == 'А1' || this.getBlockPartSOH(blockNameBparse) == 'А2' || this.getBlockPartSOH(blockNameBparse) == 'А3' || this.getBlockPartSOH(blockNameBparse) == 'А4' || this.getBlockPartSOH(blockNameBparse) == 'А5' || this.getBlockPartSOH(blockNameBparse) == 'А6' || this.getBlockPartSOH(blockNameBparse) == 'А7' || this.getBlockPartSOH(blockNameBparse) == 'А8' || this.getBlockPartSOH(blockNameBparse) == 'А9') {
                                return true;
                            } else {
                                return false;
                            }
                        } else if (blockName == '2А') {
                            if (this.getBlockPartSOH(blockNameBparse) == 'А1' || this.getBlockPartSOH(blockNameBparse) == 'А2' || this.getBlockPartSOH(blockNameBparse) == 'А3' || this.getBlockPartSOH(blockNameBparse) == 'А4' || this.getBlockPartSOH(blockNameBparse) == 'А5' || this.getBlockPartSOH(blockNameBparse) == 'А6' || this.getBlockPartSOH(blockNameBparse) == 'А7' || this.getBlockPartSOH(blockNameBparse) == 'А8' || this.getBlockPartSOH(blockNameBparse) == 'А9') {
                                return true;
                            } else {
                                return false;
                            }
                        }
                    } 
                } else if (param == 'by') {
                    // ALMATY
                    if (code == 'AKV') { // Настройка кнопок Акварель
                        if (blockName == '25' || blockName == '26' || blockName == '27' || blockName == '28') {
                            return true;
                        } else {
                            return false;
                        }
                    } else if (code == 'PRV') { // Настройка кнопок Primavera
                        if (blockName == '1' || blockName == '2') {
                            return true;
                        } else {
                            return false;
                        }
                    } else if (code == 'RPR') { // Настройка кнопок Remizovka
                        return false;
                    }
                    // ASTANA
                    else if (code == 'DSV') { // Настройка кнопок Discovery
                        if (blockName == '4') {
                            return true;
                        } else {
                            return false;
                        }
                    } else if (code == 'LDM') { // Настройка кнопок Landmark
                        // console.log(this.blockPart, 'asdasdasdasdasd')
                        if (this.getBlockPartLDM(blockNameBparse) == 4) {
                            if (blockName == '1' || blockName == '2' || blockName == '3') {
                                return true;
                            } else {
                                return false;
                            }
                        }
                    } else if (code == 'SOH') { // Настройка кнопок Soho
                        if (blockName == '2A') {
                            if (this.getBlockPartSOH(blockNameBparse) == 'А1' || this.getBlockPartSOH(blockNameBparse) == 'А2' || this.getBlockPartSOH(blockNameBparse) == 'А3' || this.getBlockPartSOH(blockNameBparse) == 'А4' || this.getBlockPartSOH(blockNameBparse) == 'А5' || this.getBlockPartSOH(blockNameBparse) == 'А6' || this.getBlockPartSOH(blockNameBparse) == 'А7' || this.getBlockPartSOH(blockNameBparse) == 'А8' || this.getBlockPartSOH(blockNameBparse) == 'А9') {
                                return true;
                            } else {
                                return false;
                            }
                        } else if (blockName == '2А') {
                            if (this.getBlockPartSOH(blockNameBparse) == 'А1' || this.getBlockPartSOH(blockNameBparse) == 'А2' || this.getBlockPartSOH(blockNameBparse) == 'А3' || this.getBlockPartSOH(blockNameBparse) == 'А4' || this.getBlockPartSOH(blockNameBparse) == 'А5' || this.getBlockPartSOH(blockNameBparse) == 'А6' || this.getBlockPartSOH(blockNameBparse) == 'А7' || this.getBlockPartSOH(blockNameBparse) == 'А8' || this.getBlockPartSOH(blockNameBparse) == 'А9') {
                                return true;
                            } else {
                                return false;
                            }
                        }
                    }
                } else {
                    return false;
                }
            },
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
            // this.$store.watch(
            //     (state) => state.flatsPage,
            //     (newValue) => {
            //         if (newValue) {
            //            this.filterSize();
            //             this.filterFloor();
            //         }
            //     }
            // );
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/flats-crm/flats-crm-items.scss';
    @import '@/styles/components/flats-crm/flats-crm-items-main.scss';
    @import '@/styles/components/flats-crm/respond/flats-crm-items-respond.scss';
    @import '@/styles/components/flats-crm/respond/flats-crm-items-main-respond.scss';
    // @import '@/styles/components/flats-page/respond/flats-item-respond.scss';
</style>